import React from 'react';
import { Helmet } from 'react-helmet';
import { useAuth } from '@clerk/clerk-react';
import { hardSignOut } from '../../services/authSession';
import Logo from '../../assets/images/logo.png';

const AccessDenied = () => {
  const { signOut } = useAuth();

  return (
    <>
      <Helmet>
        <title>Not a creator | TLK</title>
      </Helmet>
      <div className="main-body">
        <div className="body-content" style={{ display: 'flex', justifyContent: 'center' }}>
          <div
            className="user-information-card"
            style={{
              maxWidth: 420,
              width: '100%',
              margin: '48px 16px',
              textAlign: 'center',
              padding: '32px 24px',
            }}
          >
            <img
              src={Logo}
              alt="TLK"
              style={{ width: 70, height: 70, margin: '0 auto 16px' }}
            />
            <h1 className="main-header-s1__title" style={{ justifyContent: 'center', paddingBottom: 12 }}>
              You're not a creator
            </h1>
            <p style={{ color: 'var(--neon-muted, #aab4ca)', marginBottom: 24, lineHeight: 1.5 }}>
              This dashboard is only for creator accounts. You're signed in, but
              this account hasn't been set up as a creator.
            </p>
            <button
              type="button"
              className="gradient-btn full-size-btn"
              onClick={() => hardSignOut(signOut)}
            >
              <span className="text">Sign out</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccessDenied;
